/* eslint-disable eqeqeq */
import React from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { images } from "../../../config/images";
import { Button, DropDown, Input } from "../../../components";
import { WeekOptions } from "../../Coaching/CreateSession";

const CustomerCoachingBookingStep1 = (props: any) => {
  const {
    allSportsData,
    updateData,
    data,
    allSessionsData,
    handleHome,
    handleNext,
    error,
    setSessionRule,
  } = props;


  return (
    <>
      <Container fluid className="g-0">
        <Row className="g-0 position-relative row-mb">
          <h4 className="fs-5 fw-semibold mb-4 text-start">
            Sports Around You
          </h4>
          <label htmlFor="" className="form-label"></label>
          <div className="available-slot d-flex flex-wrap gap-4">
            {allSportsData?.map((item: any, index: number) => {
              return (
                <span style={{ width: "154px" }} key={"sport" + index}>
                  <Input
                    onChange={(e: any) =>
                      updateData("sportId", Number(e?.target?.value))
                    }
                    checked={data.sportId == item.id}
                    id={item.name}
                    type="radio"
                    name={item.name}
                    className="btn-check"
                    value={item.id}
                  />
                  <label
                    htmlFor={item.name}
                    className="bg-white border border-2 btn btn-sm p-4 w-100"
                  >
                    <div className="slot-box-crickt">
                      <img
                        src={item.image || images.ballicon.default}
                        alt={item.name + " logo"}
                        style={{ width: "65px", height: "65px" }}
                      />
                      <span className="d-block fs-6 mt-3">{item.name}</span>
                    </div>
                  </label>
                </span>
              );
            })}
          </div>
          <span className="error-msg mt-1 text-start top-100">
            {error?.sportId}
          </span>
        </Row>

        <Row className="align-items-end row-mb">
          <Col lg={5}>
            <div className="text-start">
              <label htmlFor="selectsession" className="form-label">
                Select No. of session per week{" "}
                <span className="text-danger">*</span>
              </label>
              <DropDown
                className="form-control"
                id="addcharges"
                value={data?.noOfDays}
                onChange={(e: any) =>
                  updateData("noOfDays", Number(e?.target?.value))
                }
              >
                <option>Select session per week</option>
                {WeekOptions?.map?.((_opt: any) => (
                  <option key={_opt?.label} value={_opt?.value}>
                    {_opt?.label}
                  </option>
                ))}
              </DropDown>
              <span className="error-msg">{error?.noOfDays}</span>
            </div>
          </Col>
        </Row>
        <Row>
          <div className="mb-3 text-start">
            <label htmlFor="selectsport" className="form-label">
              Available Sessions
            </label>
            <div className="available-slot">
              <Row>
                {allSessionsData.length > 0 ? (
                  allSessionsData?.map((item: any) => {
                    const rate =
                      item?.sessionRates?.find?.(
                        (_rate: any) => _rate?.noOfDays === data?.noOfDays
                      )?.ratePerSession * data?.noOfDays;
                    return (
                      <Col lg={4} key={item.id}>
                        <span className="text-start">
                          <Input
                            onChange={(e: any) => {
                              updateData("sessionId", Number(e?.target?.value));
                              updateData("selectedSlots", []);
                              setSessionRule(item.sessionRules);
                            }}
                            checked={data.sessionId == item.id}
                            id={item.name}
                            type="radio"
                            name={item.name}
                            className="btn-check"
                            value={item.id}
                          />
                          <label
                            htmlFor={item.name}
                            className="rounded-3 w-100"
                          >
                            <Card className="bg-white">
                              <Card.Body>
                                <div className="align-items-center d-flex justify-content-between">
                                  <span>
                                    <h5 className="fs-5 fw-bold d-block">
                                      {item.name}
                                    </h5>
                                    <span className="d-block">
                                      Start Date:{" "}
                                      <span className="text-info">
                                        {item.startDate}
                                      </span>
                                    </span>
                                    <span className="d-block text-primary">
                                      <span className="rupees-symbol">
                                        &#8377;
                                      </span>
                                      {rate.toFixed(2) || ""} / Week{" "}
                                    </span>
                                  </span>

                                </div>
                              </Card.Body>
                            </Card>
                          </label>
                        </span>
                      </Col>
                    );
                  })
                ) : (
                  <Col lg={4}>
                    <span className="text-start text-danger">
                      No Session Available
                    </span>
                  </Col>
                )}
              </Row>
            </div>
            <span className="error-msg">{error?.sessionId}</span>
          </div>
        </Row>
        <hr />
        <Row>
          <Col lg={6} className="text-start">
            <Button
              onClick={handleHome}
              type="button"
              bname="Cancel"
              name="cancel"
              id="cancel"
              className="btn btn-light rounded-1"
            ></Button>
          </Col>
          <Col lg={6} className="text-end">
            <Button
              onClick={handleNext}

              type="button"
              bname="Continue"
              name="continue"
              id="continue"
              className="btn btn-primary rounded-1"
            ></Button>
          </Col>
        </Row>
      </Container>

    </>
  );
};
export { CustomerCoachingBookingStep1 };
